import { createTheme } from '@mui/material';
import { indigo, teal, green } from '@mui/material/colors';
// import SlideUpTransition from '@atoms/SlideUpTransition';

// pallette: https://coolors.co/43bcc7-293051-ffb450-ff8870-486ffe
export const PALLETTE = {
    primary: {
        ...teal,
        50: '#f0f9fa',
        100: '#d0edf0',
        200: '#A1DDE3',
        300: '#72CDD5',
        400: '#43bcc7',
        500: '#34a3ad',
        600: '#26767E',
        700: '#1C595E',
    },
    secondary: indigo,
    warning: {
        50: '#FFF6EB',
        100: '#FFEDD6',
        200: '#FFDCAD',
        300: '#FFCA85',
        500: '#FFB450',
        main: '#FFB450',
        600: '#FFA733',
        700: '#FF950A',
        800: '#E07F00',
        900: '#B86800',
    },
    success: { ...green, 300: '#f6ffed', 500: '#52c41a', 700: '#2f780c' },
    error: {
        main: '#FF8870', // 500
        light: '#FFDCD6', // 100
        dark: '#F52900', // 800
        50: '#FFEEEB',
        100: '#FFDCD6',
        200: '#FFCCC2',
        300: '#FFAA99',
        500: '#FF8870',
        600: '#FF6647',
        700: '#FF441F',
        800: '#F52900',
        900: '#CC2200',
    },
};

export const mainWhite = '#fff';
export const secondaryGray = '#dedede';
const mainDark = '#222';
export const secondaryDark = '#333';
export const mainGray = '#a5a5a5';
export const lighterGray = '#cfcfcf';
export const grayBackground = 'whitesmoke';

export default createTheme({
    palette: PALLETTE,
    components: {
        MuiBreadcrumbs: {
            styleOverrides: {
                root: {
                    color: '#333',
                    backgroundColor: 'transparent',
                },
            },
        },
        // MuiDialog: { defaultProps: { TransitionComponent: SlideUpTransition } },
        MuiButtonGroup: {
            styleOverrides: {
                root: {
                    '& .MuiButton-root': {
                        border: '1px solid',
                        borderColor: 'primary.main',
                        '&:hover': { borderColor: 'primary.dark' },
                    },
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: '12px',
                    '&>:not(:first-of-type)': {
                        marginLeft: '12px',
                    },
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                dividers: {
                    padding: '8px 12px',
                },
                root: {
                    padding: '0px 12px 0px 12px',
                },
            },
        },
        MuiDialogContentText: {
            styleOverrides: {
                root: {
                    margin: '0px',
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    padding: '8px 12px',
                },
            },
        },
        MuiFab: {
            styleOverrides: {
                root: {
                    backgroundColor: PALLETTE.primary[500],
                    color: mainWhite,
                    '&:hover': {
                        borderColor: PALLETTE.primary[700],
                        backgroundColor: PALLETTE.primary[700],
                    },
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                colorSecondary: {
                    color: mainDark,
                },
                root: {
                    padding: '8px',
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    cursor: 'pointer',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {},
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    borderBottom: `2px solid transparent`,
                    transition: 'border-color 0.45s, background-color 0.25s',
                    '&.Mui-selected': {
                        backgroundColor: `#34a3ad20`,
                    },
                    '&:hover': {
                        backgroundColor: PALLETTE.primary[50],
                        borderBottom: `2px solid ${PALLETTE.primary[500]}`,
                    },
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: 'calc(.4vh + 4px) 12px',
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: { backgroundColor: 'rgba(0, 0, 0, 0.8)', fontSize: '1rem' },
            },
        },
        MuiToolbar: {
            defaultProps: {
                // Left align MUI Table title with table content
                disableGutters: true,
            },
            styleOverrides: {
                root: {
                    minHeight: '38px !important', // remove extra padding on table search bar
                },
            },
        },
    },
});
